<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'management'" :href="'#management'">{{ $t('Management') }}</v-tab>
      </v-tabs>

      <div v-if="tabs == 'management' && !loading">
        <Management></Management>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Management from './Management.vue'
export default {
  components: {
    Management
  },
  data() {
    return {
      loading: true,
      tabs: 'management'
    }
  },
  async created() {
    this.$store.dispatch('loading')
    this.loading = true
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.loading = false
    this.$store.dispatch('loading')
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/cityfresh/management/CityFreshManagement.vue